<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>ID</th>
          <th>ユーザーID</th>
          <th>サービス名</th>
          <th>クリック日時</th>
        </tr>
        <tr v-for="(service, index) in this.services" :key="index">
          <td>{{ service.id }}</td>
          <td>{{ service.userId }}</td>
          <td>{{ service.name }}</td>
          <td>{{ service.clickedAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from '@/constants/MasterEnum'
import firebase from 'firebase'
import utils from '@/utils/Utils'

export default {
  name : "serviceLinkInfo",
  mixins: [
    utils,
    master
  ],
  data () {
    return {
      loading : false,
      db : firebase.firestore(),
      services : [],
    }
  },
  props : {
    firstDate : {
      type : Date,
      required : true,
    },
    lastDate : {
      type : Date,
      required : true,
    }
  },
  created: function() {
    this.loading = true;
      this.db.collection("service_link_click_histories")
      .orderBy('clicked_at', 'asc')
      .startAt(this.firstDate)
      .endAt(this.lastDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          var data = doc.data();
          this.services.push({
            id : doc.id,
            userId : this.escapeNull(data.user_id),
            name : this.escapeNull(data.name),
            clickedAt : this.formatDateTime((data.clicked_at).toDate()),
          });
        });
      })
      .then(() => {
        this.loading = false;
        this.$emit('bind-event' , this.services , this.tsvFormat.serviceLinkInfo.fileName , this.tsvFormat.serviceLinkInfo.labels)
      });
  }
}
</script>
